module.exports = __webpack_public_path__ + "dingbeauty/admin/img/ga_4.9d07f95f.jpg";